import {Injectable} from '@angular/core';

/**
 * This is a singleton class
 */
@Injectable()
export class AppConfig {
    // Provide all the Application Configs here

    public version = '1.0.0';
    public locale = 'en-US';

    // API Related configs
 //public apiHostName = '3.19.52.97';
 // 'compass-prod.agnext.in' resolves via *.agnext.facets.cloud to a RELEASED IP (4.187.153.161) and is unreachable - do not re-enable.
 //public apiHostName = 'compass-prod.agnext.in/portal';
 // Production API endpoint, as served today: https://iot.qualix.ai/compass + '/api'
 public apiHostName = 'iot.qualix.ai/compass';


  //public apiHostName = '3.14.40.213';
  // public apiHostName = 'api.agnext.in';

  //  public apiHostName = '192.168.10.28';

  // Live Port
//   public apiPort = '9966';

  // QA Port
 // public apiPort = '9955';
 public apiPort = '9988';

  //   public apiPort = '9990';
    private _api_host = 'https://' + this.apiHostName;
    private _api_appender_url = '/api';
    private _api_url = this._api_host + this._api_appender_url;

    //  Cold Store
    private _cold_store_url = this._api_url + '/cold-stores';

    // Deviation Type
    private _deviation_type_url = this._api_url + '/deviation-types';

    // Vendor
    private _vendor_url = this._api_url + '/parties-type';
    // Client
    private _client_url = this._api_url + '/parties-type';

    // Save parties
    private _parties_url = this._api_url + '/parties';

    // USers
    private _users_url = this._api_url + '/users';

    // Commodity
    private _commodity_url = this._api_url + '/commodities/dd';
    private _commodities_url = this._api_url + '/commodities';

    // Profile Type
    private _profile_type_url = this._api_url + '/profile-type/dd';
    private _profiles_url = this._api_url + '/profile-type';
    // Profile

    private _profile_url = this._api_url + '/profiles';
    // Profile drop down
    private _profile_dd_url = this._api_url + '/profiles/dd';

    // Profile Type DD
    private _profile_type_dd_url = this._api_url + '/profile-type/dd';

    // All Parties drop down
    private _parties_dd_url = this._api_url + '/parties';
    // Region
    private _region_url = this._api_url + '/regions';
    // RegionDD
    private _region_dd_url = this._api_url + '/regions/dd';

    // Sites
    private _site_url = this._api_url + '/sites';

    // Barns
    private _barn_url = this._api_url + '/barns';

    private _dashboard_url = '/dashboard/main';
    private _login_url = this._api_url + '/auth/login';
    // Common
    private _common_url = this._api_url + '/common/count';
    // Users
    private _user_url = this._api_url + '/users';
    // Download S3 Path
    private _download_s3 = 'https://agnext-jasmine.s3.us-east-2.amazonaws.com/prod-itc';
    private _download_s3_excels = this._download_s3 + '/excels';
    // Global variables
    private _global_url = this._api_url + '/globals';

    // Roles
    private _role_url = this._api_url + '/roles';

    // Permission
    private _permission_url = this._api_url + '/permissions';
    // Deviation
    private _deviation_url = this._api_url + '/deviations';

    //get graph detail according to start and end date
    private _graph_detail_url = this._api_url + '/cold-stores';

    //get excel data json
    private _excel_data_json_url = this._api_url + '/cold-stores';

    //get excel file download
    private _excel_file_download_url = this._api_url + '/cold-stores';


    constructor() {
        if (this.locale === undefined) {
            this.locale = navigator.language;
        }
    }

    get api_url(): string {
        return this._api_url;
    }

    get region_url(): string {
        return this._region_url;
    }
    get region_dd_url(): string {
        return this._region_dd_url;
    }

    get dashboard_url(): string {
        return this._dashboard_url;
    }

    get login_url(): string {
        return this._login_url;
    }

    get common_url(): string {
        return this._common_url;
    }

    get user_url(): string {
        return this._user_url;
    }

    get barns_url(): string {
        return this._barn_url;
    }

    get download_s3_excels_url(): string {
        return this._download_s3_excels;
    }

    get global_url(): string {
        return this._global_url;
    }

    get role_url(): string {
        return this._role_url;
    }

    get permission_url(): string {
        return this._permission_url;
    }

    get cold_store_url(): string {
        return this._cold_store_url;
    }

    get deviation_type_url(): string {
        return this._deviation_type_url;
    }

    get vendor_url(): string {
        return this._vendor_url;
    }

    get client_url(): string {
        return this._client_url;
    }

    get parties_url(): string {
        return this._parties_url;
    }

    get users_url(): string {
        return this._users_url;
    }

    get profile_url(): string {
        return this._profile_url;
    }

    get commodity_url(): string {
        return this._commodity_url;
    }
    get site_url(): string {
        return this._site_url;
    }

    get commodities_url(): string {
        return this._commodities_url;
    }

    get profile_type_url(): string {
        return this._profile_type_url;
    }

    get profiles_url(): string {
        return this._profiles_url;
    }

    get profile_dd_url(): string {
        return this._profile_dd_url;
    }

    get profile_type_dd_url(): string {
        return this._profile_type_dd_url;
    }

    get parties_dd_url(): string {
        return this._parties_dd_url;
    }

    get deviation_url(): string {
        return this._deviation_url;
    }


    get graph_detail_url(): string {
        return this._graph_detail_url;
    }

    get excel_file_download_url(): string {
        return this._excel_file_download_url;
    }
    get excel_data_json_url(): string {
        return this._excel_data_json_url;
    }

}
